export enum ProductQuotesTypeEnum {
  Physical = 1,
  Future
}
